import { Link } from "react-router-dom";
import { IconReceipt } from "../components/icons";
import { useI18n } from "../i18n";
import { useBrand } from "../branding/BrandContext";
import { PageShell } from "./PageShell";

export function Home() {
  const { t } = useI18n();
  const brand = useBrand();
  return (
    <PageShell narrow>
      <main className="center-card panel" id="main">
        <span className="result-icon result-icon-neutral" aria-hidden="true">
          <IconReceipt size={26} />
        </span>
        <h1 className="h1">{t("home.title")}</h1>
        <p className="muted">{t("home.body")}</p>
        {import.meta.env.DEV || brand.demoMode ? (
          <Link className="link" to="/demo">
            {t("home.demo")}
          </Link>
        ) : null}
      </main>
    </PageShell>
  );
}
